var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataLoading)?_c('section',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.dataLoading),expression:"dataLoading"}],staticClass:"loading-component"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }